import React from 'react';
import PropTypes from 'prop-types';

export default function SummarySection ({ title, children }) {
  if (!children) return null;
  return (
    <div className="mb-3">
      <h6 className="border-bottom pb-1 mb-2 text-uppercase fw-semibold small">{title}</h6>
      {typeof children === 'string' ? <p>{children}</p> : children}
    </div>
  );
}
SummarySection.propTypes = { title: PropTypes.string.isRequired, children: PropTypes.node };
